import { Component, computed, effect, input, signal } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-child-tab',
    templateUrl: './child-tab.template.html',
    styleUrl: './child-tab.style.scss',
    standalone: true,
})
export class ChildTabComponent {
    /**
     * The value that identifies the tab, it will be emitted when the tab is selected
     */
    value = input.required<string>();
    /**
     * Whether this tab is initially active (NOTE: if multiple tabs are given this property, it will only apply to the last one added to the DOM)
     */
    initiallyActive = input<boolean>(false);

    /**
     * The id of the tab that's currently active. This is controlled by the parent child-tab-bar component
     */
    currentlyActiveId = signal('');

    /**
     * Whether this tab is currently active
     */
    isActive = computed(() => this.value() === this.currentlyActiveId());

    /**
     * Event emitter when the tab is clicked
     */
    onClick = new ReplaySubject<string>();

    /**
     * If a tab has the initiallyActive attribute set, we use it to communicate to the parent that it is active and then destroy the effect so it's only run once
     */
    private resetInitiallyActive = effect(
        () => {
            if (this.initiallyActive()) {
                this.onClick.next(this.value());
            }
            this.resetInitiallyActive.destroy();
        },
        { allowSignalWrites: true }
    );
}
